import { User } from "@hl/shared-features/lib/features/auth/User";
import UserSkeleton from "@hl/shared-features/lib/features/auth/UserSkeleton";

import useMintState from "~hooks/useMintState";

export default function SimplePublicUserProfile(props: {
  addressOrEns?: string | null;
  avatarSize?: number;
}) {
  const { collection } = useMintState();
  const { avatarSize } = props;

  if (
    !collection ||
    !collection.creatorAddresses ||
    !collection.creatorAccountSettings
  )
    return <UserSkeleton />;

  return (
    <>
      <User
        avatarSize={avatarSize}
        avatarUrl={collection.creatorAccountSettings.displayAvatar}
        displayName={collection.creatorAccountSettings.displayName}
        walletAddresses={collection.creatorAccountSettings.walletAddresses}
        verified={!!collection.creatorAccountSettings.verified}
        imported={!!collection.creatorAccountSettings.imported}
        enableLink
      />
    </>
  );
}
